/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";

class Switcher extends React.Component {
  handleOptionClick(option, e) {
    e.preventDefault();

    //Fire our passed in function with newly selected value
    this.props.handleNewSelection(option);
  }

  renderOptionStyle(option) {
    const isActive = this.props.currentlyActiveKey === option;
    return {
      textTransform: "capitalize",
      textDecoration: "none",
      padding: "1em 0",
      width: "50%",
      textAlign: "center",
      borderTop: isActive ? "0.3em solid #739BFA" : "0.3em solid #F0ECEC",
      background: isActive ? "#4A90E2" : "#FAFAFA",
      borderBottom: isActive ? "0.3em solid #4A90E2" : "0.3em solid #FAFAFA",
      color: isActive ? "#FAFAFA" : "#200535"
    };
  }

  render() {
    const containerStyle = {
      display: "flex",
      width: "28em",
      margin: "1em auto 3em"
    };

    return (
      <div style={containerStyle} className="Switcher">
        {this.props.options.map((option, i) => {
          return (
            <a
              key={i}
              href="#"
              style={this.renderOptionStyle(option)}
              onClick={this.handleOptionClick.bind(this, option)}
            >
              {option}
            </a>
          );
        })}
      </div>
    );
  }
}

export default Switcher;



// WEBPACK FOOTER //
// ./src/b5-unlocks/Switcher.js